import React, { useState } from 'react';
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  Box
} from '@mui/material';

// Lista fixa de campos disponíveis
const availableFields = [
  { key: 'nome', label: 'Nome' },
  { key: 'descricao', label: 'Descrição' },
  { key: 'status', label: 'Status' },
  { key: 'subgrupo', label: 'SubGrupo' },
  { key: 'categoria', label: 'Categoria' },
  // etc... adicione quantos quiser
];

export default function TelaDinamica() {
  // Guarda a lista de chaves selecionadas (ex.: ['nome', 'status'])
  const [selectedKeys, setSelectedKeys] = useState([]);

  // Handler para quando o usuário seleciona/deseleciona campos
  const handleSelectChange = (event) => {
    const { value } = event.target; // array de chaves selecionadas
    setSelectedKeys(value);
  };

  // Função para "gerar" o relatório (ou chamar o backend)
  const handleGerarRelatorio = () => {
    // Aqui você chamaria seu backend, por exemplo com fetch/axios
    // Exemplo (fictício):
    // axios.post('/api/relatorio', { campos: selectedKeys })
    //   .then((response) => { ... })

    alert(`Campos selecionados: ${selectedKeys.join(', ')}`);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Seletor de Campos para Relatório
        </Typography>

        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
          <InputLabel id="select-campos-label">Campos Disponíveis</InputLabel>
          <Select
            labelId="select-campos-label"
            multiple
            value={selectedKeys}
            onChange={handleSelectChange}
            label="Campos Disponíveis"
            renderValue={(selected) =>
              selected
                .map((key) => {
                  const found = availableFields.find((f) => f.key === key);
                  return found?.label ?? key;
                })
                .join(', ')
            }
          >
            {availableFields.map((field) => (
              <MenuItem key={field.key} value={field.key}>
                {field.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ mt: 3 }}>
          <Button variant="contained" onClick={handleGerarRelatorio}>
            Gerar Relatório
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
